import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';
import { BORROWER_VESTING_TYPES_ACTION_TYPE } from 'store/system/actions';

const initialState = {};

const borrowerVestingTypesReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case BORROWER_VESTING_TYPES_ACTION_TYPE.GET_TYPES:
        return payload || initialState;

      case BORROWER_VESTING_TYPES_ACTION_TYPE.CREATE_TYPE:
      case BORROWER_VESTING_TYPES_ACTION_TYPE.EDIT_TYPE:
        draft[payload.vestingTypeId] = payload;
        break;

      case BORROWER_VESTING_TYPES_ACTION_TYPE.DELETE_TYPE:
        delete draft[meta.vestingTypeId];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default borrowerVestingTypesReducer;
